import React from 'react';
import PropTypes from 'prop-types';
import useBreakpointRef from '../../hooks/useBreakpointRef';

const BREAKPOINTS = Object.freeze([724, 900]);
const BREAKPOINT_VALUES = Object.freeze(['24px 16px', '30px 24px', '30px 48px']);

const ChartWrapper = props => {
  const { children } = props;

  const { ref, breakpointValue: padding } = useBreakpointRef({
    breakpoints: BREAKPOINTS,
    breakpointValues: BREAKPOINT_VALUES
  });

  return (
    <div ref={ref} className="chart-wrapper">
      {React.Children.map(children,
        child => React.cloneElement(child, {
          padding
        }))}
    </div>
  )
}

ChartWrapper.propTypes = {
  children: PropTypes.node
};

export default ChartWrapper;
